<template>
  <div class="container">
    <Header :theme="theme"></Header>
    <div class="fullPage" ref="fullPage">
      <div
        class="fullPageContainer"
        ref="fullPageContainer"
        @mousewheel="mouseWheelHandle" 
        @DOMMouseScroll="mouseWheelHandle"
      >
        <div :class="`banner ${fullpage.current===1?'in':'out'}`" :style="`background-image: url(${bannerBack})`">
          <div class="content">
            <div class="text">
              <p class="name">产品中心</p>
              <p class="en">Product Center</p>
            </div>
          </div>
        </div>
        <div>
          <div :class="`detail ${fullpage.current===2?'in':'out'}`" :style="`background-image: url(${detailBack})`">
            <div class="content">
              <div class="title">
                <p class="en">Product Center</p>
                <div class="divider"></div>
                <p class="cn">产品中心</p>
              </div>
              <div class="text">
                <div class="list" v-if="dataList.length>0">
                  <div class="item" :style="`background-image: url(${item.cover})`" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)">
                    <div class="name">
                      {{item.name}}
                    </div>
                  </div>
                </div>
                <el-empty class="empty" description="暂无产品" v-else></el-empty>
                <el-pagination
                  @current-change="getData"
                  :hide-on-single-page="true"
                  :current-page.sync="filter.pageNum"
                  :page-size="filter.pageSize"
                  background
                  layout="prev, pager, next, jumper, total"
                  :total="totalCount">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import Header from "@/layout/Header"
import { 
  api_getClientProductList,
} from "@/api/common"
export default {
  components:{
    Header,
  },
  data(){
    return{
      bannerBack:require("@/assets/img/products/banner.png"),
      detailBack:require("@/assets/img/back.png"),
      theme:"white",
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      filter:{
        pageNum:1,
        pageSize:8,
      },
      dataList:[],
      totalCount:0,
    }
  },
  created(){
    if(Cookies.get('productPageNum')){
      this.filter.pageNum=Number(Cookies.get('productPageNum'))
      Cookies.remove('productPageNum')
    }
    this.getData()
  },
  updated(){
    if(Cookies.get('productCurrent')){
      this.move(Number(Cookies.get('productCurrent')))
      Cookies.remove('productCurrent')
    }
  },
  methods:{

    //获取数据
    getData(){
      api_getClientProductList(this.filter)
        .then((res)=>{
          if(res && res.code===0){
            this.dataList=res.data.records
            this.totalCount=res.data.total
          }
        })
    },

    //去详情页
    goDetail(id){
      Cookies.set('productPageNum',this.filter.pageNum)
      Cookies.set('productCurrent',2)
      this.$router.push({
        name:'product-detail',
        query:{
          id
        }
      })
    },

    next() { // 往下切换
      let len = 2; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
      this.fullpage.current += 1; // 页面+1
      this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
      this.fullpage.current -= 1;// 页面+1
      this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      if(index==2){
        this.theme="black"
      }else{
        this.theme="white"
      }
      setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
      this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight= -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
      evt.stopPropagation();
      } else {
      evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
      return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
      this.next();
      } else if (this.fullpage.deltaY < 0) {
      this.pre();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  animation-timing-function: ease;

  .fullPage{
    height: 100vh;
    overflow: hidden;

    .fullPageContainer{
      width: 100%;
      height: 100vh;
      transition: all linear 1s;

      .banner{
        width: 100%;
        height: 100vh;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .content{
          width: 100rem;
          margin: 0 auto;
          color: #fff;
          height: 57.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          .text{

            .name{
              font-size: 8.125rem;
              line-height: 9.75rem;
              letter-spacing: .625rem;
              font-weight:bold;
            }
            .en{
              font-size: 2.8125rem;
              line-height: 3.6875rem;
              font-weight: 400;
              margin-top: 1rem;
            }
          }
        }
      }
      .detail{
        width: 100%;
        height: 100vh;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .content{
          width: 100rem;
          height: 57.5rem;
          margin: 0 auto;
          color: #303133;
          box-sizing: border-box;

          .title{
            margin-top: 9.375rem;

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight: bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #373737;
            }
            .cn{
              margin-top: 1.25rem;
              font-size: 2rem;
              line-height: 2.375rem;
              font-weight: bold;
            }
          }
          .text{
            position: relative;
            margin-top: 1.25rem;

            .list{
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;

              .item{
                width: 23.75rem;
                height: 17.5rem;
                margin: 0 1.25rem 1.25rem 0;
                box-sizing: border-box;
                // padding: 1.25rem;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                box-shadow: .9375rem .9375rem 1.25rem .9375rem rgba(0,0,0,0.05);
                border-radius: .625rem;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                position: relative;

                .name{
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  text-align: center;
                  font-size: 1.125rem;
                  font-weight: bold;
                  line-height: 3.125rem;
                  height: 3.125rem;
                  background-color: rgba(47, 47, 47, 0.60);
                  color: #fff;
                }
              }
              .item:hover{
                border: .125rem solid #fff;
                cursor: pointer;
              }
              .item:nth-child(4n){
                margin-right: 0;
              }
            }
            .empty{
              /deep/ .el-empty__image{
                width: 28.125rem;
                height: 28.125rem;
              }
            }
            .el-pagination{
              text-align: right;
            }
          }
        }
      }
      .in{
        .text{
          animation: show 1s ease-out;
        }
        .title{
          animation: transIn 1s ease-out;
        }
      }
      .out{
        .text{
          animation: hidden 1s ease-out;
        }
        .title{
          animation: transOut 1s ease-out;
        }
      }
      @keyframes show {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      @keyframes hidden {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }
      @keyframes transIn {
        from {
          transform: translate(-25rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(-25rem, 0);
        }
      }
    }

  }
}
</style>